import { CreateGrupoModalForm } from "./CreateGrupoModalForm"


const CreateGrupoModalFormWrapper = () => {
    return (<CreateGrupoModalForm />)
}

export {CreateGrupoModalFormWrapper}